import React, { useEffect, useState } from 'react';
import _includes from 'lodash/includes';
import { useSelector } from 'react-redux';
import { checkUserFlag, setUserSetting } from '@zola-helpers/client/dist/es/util/userSettings';
import { isPostWedding } from '@zola-helpers/client/dist/es/util/dateUtils';

// types
import type { RootState } from 'reducers/index';
import { getUserWeddingDate, getWebsiteSlug } from 'selectors/user';

import PostWeddingCelebrationContent from './PostWeddingCelebrationContent';

const PostWeddingCelebration = (): JSX.Element | null => {
  const USER_SETTINGS = 'PostWeddingCelebration';
  const weddingDate = useSelector((state: RootState) => getUserWeddingDate(state));
  const websiteSlug = useSelector((state: RootState) => getWebsiteSlug(state));

  const [showModal, setShowModal] = useState(false);

  const isWebsitePreview = _includes(window.location.pathname, `/wedding/${websiteSlug}`);
  const shouldSeeModal = weddingDate && isPostWedding(weddingDate) && !isWebsitePreview;

  useEffect(() => {
    if (shouldSeeModal) {
      const hasSeenModalPromise = checkUserFlag(USER_SETTINGS);
      Promise.all([hasSeenModalPromise])
        .then(([hasSeenModal]) => {
          if (!hasSeenModal) setUserSetting(USER_SETTINGS).catch(console.error); // eslint-disable-line no-console
          setShowModal(!hasSeenModal);
        })
        .catch((e) => {
          console.error(e); // eslint-disable-line no-console
          // Something when wrong, just don't show the modal.
          setShowModal(false);
        });
    }
  }, [shouldSeeModal]);

  if (!shouldSeeModal || !showModal) return null;

  return <PostWeddingCelebrationContent setShowModal={setShowModal} />;
};

export default PostWeddingCelebration;
